import React from "react";

export const NotFound = React.lazy(() => import("./NotFound/index.page"));
export const WelcomePage = React.lazy(() => import("./LandingPage/index.page"));
